<div *ngIf="screenWidth > 1024" class="single-box-description" [ngClass]="{
    'hide-description-items':activeCredits,
    'text-left':module.content_align == 'left',
    'text-right':module.content_align == 'right',
    'text-center':module.content_align == 'center',
    'vertical-center':module.vertical_align =='center',
    'vertical-top':module.vertical_align =='top',
    'vertical-bottom':module.vertical_align =='bottom',
    'animate':animateItem}">
    <h1 *ngIf="module.title" class="heading1 f-darker">{{module.title}}</h1>
    <h2  *ngIf="subtitle && module.mobile_order == '2' && screenWidth <= 767" class="heading2 f-darker separate-top-3">{{subtitle}}</h2>
    <h3  *ngIf="module.subtitle" class="heading3 f-darker separate-top-3 f-darker">{{module.subtitle}}</h3>
    <p  *ngIf="module.description" class="paragraph1 font-light separate-top-5 f-darker" [innerHtml]="module.description"></p>
</div>
<button *ngIf="module.credits && getCountry" class="single-credits-toggle separate-top-3" [ngClass]="{'active-credits-button':activeCredits}" (click)="creditsAcitve()">
    <div class="float-left separate-right-1">Credits</div>
    <span class="item-toggle item-vertical"></span>
    <span class="item-toggle  item-horizontal"></span>
</button>
<div *ngIf="module.credits && getCountry" class="w-100 H-100 credits-container" [ngClass]="{'credits-container-active':activeCredits}">  
    <app-credits-module 
    [module]="module"
    ></app-credits-module>
</div>


<div *ngIf="screenWidth <= 1024" class="single-box-description vertical-center" [ngClass]="{
    'hide-description-items':activeCredits,
    'text-left':module.content_align == 'left',
    'text-right':module.content_align == 'right',
    'text-center':module.content_align == 'center',
    'animate':animateItem}">
    <h1 *ngIf="module.title" class="heading1 heading-2-3-m f-darker">{{module.title}}</h1>
    <h2  *ngIf="subtitle && module.mobile_order == '2' && screenWidth <= 767" class="heading2 header-2-m f-darker separate-top-3">{{subtitle}}</h2>
    <h3  *ngIf="module.subtitle" class="heading3  header-3-m f-darker separate-top-3 f-darker">{{module.subtitle}}</h3>
    <p  *ngIf="module.description" class="paragraph1 paragraph1-m font-light separate-top-5 f-darker" [innerHtml]="module.description"></p>
</div>
<div class="view-port-detect"
inViewport
[inViewportOptions]="{ threshold: [0] }"
(inViewportAction)="onIntersection($event)">

</div>